import { createAction, handleActions } from 'redux-actions'

const setPagination = createAction('SCREENS/SUBCONTRACTOR_SUB_ORDERS/SET_PAGINATION')
const firstPage = createAction('SCREENS/SUBCONTRACTOR_SUB_ORDERS/FIRST_PAGE')
const resetPagination = createAction('SCREENS/SUBCONTRACTOR_SUB_ORDERS/RESET_PAGINATION')

const defaultState = {
  pageNumber: 1,
  pageSize: 10,
  total: 0,
}

const reducer = handleActions(
  {
    [setPagination]: (state, { payload }) => ({ ...state, ...payload }),
    [firstPage]: (state) => ({ ...state, pageNumber: 1 }),
    [resetPagination]: () => defaultState,
  },
  defaultState,
)

export { setPagination, firstPage, resetPagination, reducer }
